export const CHANGE_MAP = "CHANGE_MAP"

interface MapAction {
  type: typeof CHANGE_MAP
  value: object
}

export type MapActionTypes = MapAction
